module.exports = __webpack_public_path__ + "static/media/ajuda-corlett.ebce140c.png";